<template>
    <grid class="g-m c-m">
        <row class="height60"  :reverse="!1" middle="xs" center="xs">
            <column :xs="2">
                <i class="far fa-user fa-2x"></i>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" :value="email" type="text" readonly>
            </column>
            <column :xs="3"></column>
        </row>
        <row  class="dpli-h height60"  :reverse="!1" middle="xs" center="xs" @click="$router.push({name: 'settings_map'})">
            <column :xs="2">
                <i class="far fa-map-marked fa-2x"></i>
            </column>
            <column :xs="10" class="align-left">
                <b>{{$t('settings.map_mng_label')}}</b>
            </column>
        </row>
<!--        <row class="dpli-h height60"  :reverse="!1" middle="xs" center="xs">-->
<!--            <column :xs="2">-->
<!--                <i class="far fa-layer-group fa-2x"></i>-->
<!--            </column>-->
<!--            <column :xs="10" class="align-left">-->
<!--                <b>{{$t('settings.grp_mng_label')}}</b>-->
<!--            </column>-->
<!--        </row>-->
        <row class="dpli-h height60"  :reverse="!1" middle="xs" center="xs" @click="$router.push({name: 'settings_lang'})">
            <column :xs="2">
                <i class="far fa-language fa-2x"></i>
            </column>
            <column :xs="10" class="align-left">
                <b>{{$t('settings.ch_lng_label')}}</b>
            </column>
        </row>
<!--        <row class="dpli-h height60"  :reverse="!1" middle="xs" center="xs">-->
<!--            <column :xs="2">-->
<!--                <i class="far fa-bell fa-2x"></i>-->
<!--            </column>-->
<!--            <column :xs="10" class="align-left">-->
<!--                <b>{{$t('settings.nt_label')}}</b>-->
<!--            </column>-->
<!--        </row>-->
<!--        <row class="dpli-h height60"  :reverse="!1" middle="xs" center="xs">-->
<!--            <column :xs="2">-->
<!--                <i class="far fa-lock-alt fa-2x"></i>-->
<!--            </column>-->
<!--            <column :xs="10" class="align-left">-->
<!--                <b>{{$t('settings.change_pwd_label')}}</b>-->
<!--            </column>-->
<!--        </row>-->
        <row :reverse="!1" class="height60 dpli-h" start="xs" middle="xs"  @click="logout">
            <column :xs="4">
                <b>{{$t('settings.logout_label')}}</b>
            </column>
            <column :xs="8"></column>
        </row>
    </grid>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Settings',
  computed: {
    ...mapGetters({
      email: 'getEmail'
    })
  },
  methods: {
    logout () {
      this.$store.dispatch('authLogout').then(() => {
        this.$router.push({name: 'Login'})
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/Settings.vue